import fetchTBTSignings from '../Services/fetchTBTSignings'

export default (filters) => (dispatch, getState) => {
  dispatch({
    type: 'TBT_SIGNING_SET_FILTERS',
    payload: filters,
  })

  const { searchTerm, pagination } = getState().screens.TBTSigning
  
  dispatch(fetchTBTSignings({
    search: searchTerm,
    filters,
    page: 1, // Reset to first page on filter change
    per_page: pagination.pageSize,
  }))
}
